import PageHero from "@/components/UI/PageHero";
import { FaMapMarkerAlt, FaRegCommentDots } from "react-icons/fa";
import yobstiLaden from "@/public/img/yobsti-laden.png";
import TextImage from "@/components/UI/ImageText";
import POS from "@/public/img/POS.jpg";
import ImageTextGrid from "@/components/UI/ImageTextGrid";
import andre from "@/public/img/team/andre.png";
import luis from "@/public/img/team/luis.png";
import marion from "@/public/img/team/marion.jpg";
import konrad from "@/public/img/team/konrad.jpg";
import alfred from "@/public/img/team/alfred.png";
import ingo from "@/public/img/team/ingo.jpg";
import viktoria from "@/public/img/team/viktoria.jpg";
import joerg from "@/public/img/team/joerg.png";
import seoImg from "@/public/img/seo/ueber-uns.png";
import SeoHelmet from "@/components/UI/SeoHelmet";
import ActionLink from "@/components/UI/ActionLink";
import WhatsAppButton from "@/components/UI/WhatsAppButton";
import { TEO_STORES_REOPENED } from "@/data/teoTransition";
import JobDownloads, { type JobPdf } from "@/components/UI/JobDownloads";
import minijobSchwanheimVoelkersweiler from "@/public/pdf/Stellenanzeige_Minijob_Schwanheim_Voelkersweiler_bewerbung_yobsti.pdf";
import minijobKnittelsheim from "@/public/pdf/Stellenanzeige_Minijob_Knittelsheim.pdf";

export default function AboutUsPage() {

    const jobPdfs: JobPdf[] = [
        {
            title: 'Minijobber:in für Dorfladen Schwanheim/Völkersweiler',
            filename: minijobSchwanheimVoelkersweiler,
            lines: ["Vorort", "ab sofort", "flexibel"]
        },
        {
            title: 'Minijobber:in für Dorfladen Knittelsheim',
            filename: minijobKnittelsheim,
            lines: ["Vorort", "ab sofort", "flexibel"]
        },
    ];

    return (
        <>
            <SeoHelmet
                title="Yobsti – Beschreibung über das Yobsti-Team"
                description="Entdecken was Yobsti macht und welches Team dahinter steht."
                image={seoImg}
                url="https://www.yobsti.de/ueber-uns"
            />

            <PageHero
                eyebrow="Über uns"
                title={<>Große Lust auf<br />kleine Läden.</>}
                text="Milch fürs Frühstück. Pasta fürs Abendessen. Oder die Schokolade, die auf keinem Einkaufszettel stand. Wir finden: Für die kleinen Dinge des Alltags sollte der Weg genauso klein sein."
                illustration={yobstiLaden}
            >
                <div className="mt-8 flex flex-wrap gap-3">
                    <ActionLink to="/standorte" variant="solid" event="cta-click" eventData={{ target: 'find-store', location: 'about-hero' }}>
                        <FaMapMarkerAlt className="h-4 w-4" aria-hidden="true" />
                        Deinen Yobsti finden
                    </ActionLink>
                    <ActionLink to="/fuer-kunden#feedback" event="cta-click" eventData={{ target: 'feedback', location: 'about-hero' }}>
                        <FaRegCommentDots className="h-4 w-4" aria-hidden="true" />
                        Deine Ideen einbringen
                    </ActionLink>
                </div>
            </PageHero>

            <TextImage
                title="Nah dran an deinem Alltag."
                list={[
                    "Ein Lebensmittelmarkt im Ort spart Wege und macht den Alltag leichter. Genau dafür steht Yobsti. Wir betreiben Märkte, in denen du selbstständig einkaufen kannst, und entwickeln unser Angebot gemeinsam mit den Menschen vor Ort weiter.",
                    "Digitale Technik unterstützt den Zugang, den Einkauf und den Betrieb unserer Märkte. Gleichzeitig braucht ein guter Laden Menschen, die sich kümmern, zuhören und Verbesserungen umsetzen. Deshalb möchten wir für deine Fragen und Ideen erreichbar sein.",
                    "Zu unserem Sortiment gehören Produkte für den täglichen Bedarf. Passende regionale Angebote möchten wir Schritt für Schritt ergänzen. Was du dir wünschst und welche Anbieter wir kennenlernen sollten, kannst du uns direkt mitteilen.",
                    TEO_STORES_REOPENED
                        ? "Mit der Übernahme bisheriger teo-Märkte führen wir weitere Standorte unter dem Namen Yobsti weiter. Aktuelle Öffnungszeiten und Informationen findest du auf der jeweiligen Standortseite."
                        : "Wir bereiten die Übernahme bisheriger teo-Märkte vor und möchten diese unter dem Namen Yobsti weiterführen. Aktuelle Öffnungszeiten und Informationen findest du auf der jeweiligen Standortseite.",
                ]}
                actions={
                    <>
                        <ActionLink to="/standorte" variant="solid" event="cta-click" eventData={{ target: 'find-store', location: 'about' }}>Yobsti in meiner Nähe finden</ActionLink>
                        <WhatsAppButton location="about" label="Kontakt per WhatsApp" variant="outline" />
                    </>
                }
                imageUrl={POS}
                imageAlt="Pos"
                imageLeft={false}
            ></TextImage>

            <ImageTextGrid
                title="Die Köpfe hinter den Dächlis."
                slides={[
                    {
                        imageUrl: andre,
                        title: "Andre",
                        subtitle: "Geschäftsführung",
                    },
                    {
                        imageUrl: marion,
                        title: "Marion",
                        subtitle: "Operative Leitung",
                    },
                    {
                        imageUrl: ingo,
                        title: "Ingo",
                        subtitle: "Technik und Instandhaltung",
                    },
                    {
                        imageUrl: luis,
                        title: "Luis",
                        subtitle: "Marketing und Kundenservice",
                    },
                    {
                        imageUrl: konrad,
                        title: "Konrad",
                        subtitle: "Marketing und Kommunikation",
                    },
                    {
                        imageUrl: viktoria,
                        title: "Viktoria",
                        subtitle: "Sicherheits- und Vertragsmanagement",
                    },
                    {
                        imageUrl: joerg,
                        title: "Jörg",
                        subtitle: "Planung und Entwicklung",
                    },
                    {
                        imageUrl: alfred,
                        title: "Alfred",
                        subtitle: "Technik und Instandhaltung",
                    }
                ]}>

            </ImageTextGrid>

            <section id="jobs" className="w-full max-w-6xl mx-auto px-4 py-4">
                <div className="mb-4">
                    <h2 className="text-3xl font-bold text-textColor mb-4">Unsere Stellenausschreibungen</h2>
                    <p className="text-sm text-gray-500 mt-1">Werde Teil von Yobsti!</p>
                </div>
                <JobDownloads jobs={jobPdfs} />
            </section>
        </>
    );
}
